module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_b1_dark.c30a85aa.svg";